import { SurveyTemplateEditPageStep } from "@/pages/talent/surveys/templates/edit/survey-template-edit.ts";
import { ApiFormTemplate } from "@/types/forms/form-template.types.ts";
import { LinkTo, Stack, Text } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

export interface SurveyTemplateEditSidebarProps {
  step: SurveyTemplateEditPageStep;
  template?: ApiFormTemplate;
}

export const SurveyTemplateEditSidebar = ({ step, template }: SurveyTemplateEditSidebarProps) => {
  const { t } = useTranslation();

  const menuItems = [
    {
      step: SurveyTemplateEditPageStep.details,
      title: t("common:details"),
    },
    {
      step: SurveyTemplateEditPageStep.questions,
      title: t("common:questionnaire"),
    },
  ];
  const currentStepIndex = menuItems.findIndex((item) => item.step === step);

  return (
    <Stack className={"px-6"} gap={"md"}>
      {menuItems.map((item, itemIndex) => {
        const className = step === item.step ? "text-default" : "text-secondary";
        const isLinkAvailable =
          template && (itemIndex < currentStepIndex || template.title.length > 0);

        if (!isLinkAvailable) {
          return (
            <Text key={item.step} className={className}>
              {item.title}
            </Text>
          );
        }

        return (
          <LinkTo
            key={item.step}
            to={`/templates/surveys/${template.id}/setup/${item.step}`}
            variant={"plain"}
            className={className}
          >
            <Text>{item.title}</Text>
          </LinkTo>
        );
      })}
    </Stack>
  );
};
